import { ScreenContext } from '@/contexts/ScreenContext';
import { useObserveElementRect } from '@/hooks/useObserveElementRect';
import { TypographyProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import './index.scss';

const STANDARD_FONT_SIZE = 16;
type AutoTypographyOwnProps = {
    isPortraitWithScaleFactor?: boolean;
};
type AutoTypographyProps = AutoTypographyOwnProps & TypographyProps;
export const AutoTypography = (props: AutoTypographyProps) => {
    const {
        isPortraitWithScaleFactor = false,
        children,
        textAlign,
        ...otherProps
    } = props;
    const { ref: containerRef, rect: containerRect } =
        useObserveElementRect<HTMLDivElement>();
    const { ref: textRef } = useObserveElementRect<HTMLSpanElement>();
    const [fontSize, setFontSize] = useState(STANDARD_FONT_SIZE);
    const { isLandscape, scaleFactor } = useContext(ScreenContext);

    useEffect(() => {
        const isString = typeof children === 'string';
        if (isString && containerRect !== undefined) {
            const calculationWidth =
                (containerRect.width / children.length) * 1.65;
            let fontWidth = STANDARD_FONT_SIZE;

            if (isLandscape) {
                const vh = parseFloat(
                    document.documentElement.style.getPropertyValue('--vh')
                );
                fontWidth = Math.max(vh * 1 * 3, 16);
            } else {
                fontWidth = Math.min(
                    STANDARD_FONT_SIZE *
                        (isPortraitWithScaleFactor ? scaleFactor : 1),
                    calculationWidth
                );
            }

            setFontSize(fontWidth);
        }
    }, [children, containerRect]);
    useEffect(() => {
        console.log('auto::typography', children, containerRect?.width);
    }, [containerRect]);
    return (
        <Box
            className="auto-text-container"
            ref={containerRef}
            textAlign={textAlign ?? 'center'}
            lineHeight={props.lineHeight}
        >
            <Typography
                component={'span'}
                fontSize={`${fontSize}px`}
                {...otherProps}
                ref={textRef}
            >
                {children}
            </Typography>
        </Box>
    );
};
